export var REQUEST_SEAT_UPGRADE = 'requestSeatUpgrade';
export var REQUEST_SEAT_UPGRADE_BANNER = 'requestSeatUpgradeBanner';
export var REQUEST_ADDITIONAL_SEATS = 'requestAdditionalSeats';
export var REQUEST_SEAT_BANNER = 'requestSeatBanner';
export var REQUEST_SKU = 'requestSKU';
export var REQUEST_TRIAL = 'requestTrial';
export var REQUEST_REMOTE_TOOLS = 'requestRemoteTools';
export var REQUEST_QUOTE = 'requestQuote';
export var REQUEST_PARTNER = 'requestPartnerScope';
export var REQUEST_PRODUCT = 'requestProduct';
export var REQUEST_MC_WRITE = 'requestMCWrite';
export var DEFAULT = 'default';